import styled from 'styled-components'

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Title = styled.span`
  font-weight: 600;
`

export const Summary = styled.span`
  color: #a0a1a2;
  font-size: 13px;
`
